import React from 'react';
import ChemistryOfProgress from '../components/ChemistryOfProgress';

function ChemistryOfProgressPage() {
  return <ChemistryOfProgress />;
}

export default ChemistryOfProgressPage;
